import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TG4Loader',
  props: {
    label: null,
    hideLabel: { type: Boolean },
    compact: { type: Boolean },
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  label?: string;
  hideLabel?: boolean;
  compact?: boolean
  small?: boolean
};





return { __sfc: true,props }
}

})